import { BaseAPI } from '../manager/base';
import type { TeamAuditConfigEntity } from '../../types/team/team_audit_config';
import apiClient from '../apiClient';
import type { BaseResponse } from '../../types/base.dto';

export class TeamAuditConfigAPI extends BaseAPI<TeamAuditConfigEntity> {
  constructor() {
    super('/teams/:id/audit-configs');
  }

  // BaseAPI requires concrete path, we override create and update here for specific path
  createWithTeam(teamId: number, data: Partial<TeamAuditConfigEntity>): Promise<BaseResponse<TeamAuditConfigEntity>> {
    return apiClient.post<BaseResponse<TeamAuditConfigEntity>>(`/teams/${teamId}/audit-configs`, data).then(res => res.data);
  }

  updateWithTeam(teamId: number, configId: number, data: Partial<TeamAuditConfigEntity>): Promise<BaseResponse<TeamAuditConfigEntity>> {
    return apiClient.put<BaseResponse<TeamAuditConfigEntity>>(`/teams/${teamId}/audit-configs/${configId}`, data).then(res => res.data);
  }

  deleteWithTeam(teamId: number, configId: number): Promise<BaseResponse<any>> {
    return apiClient.delete<BaseResponse<any>>(`/teams/${teamId}/audit-configs/${configId}`).then(res => res.data);
  }
}

export const teamAuditConfigApi = new TeamAuditConfigAPI();
export default teamAuditConfigApi;